module.exports = __webpack_public_path__ + "src/assets/img/lenta.4b178d05.jpg";